module.exports = __webpack_public_path__ + "static/media/send-icon.71b61e84.svg";